import { createUseRBAC } from 'features/Auth/utils/hooks/useRBAC'

export const flexiComboChooseProductRolesRBAC = {
  pageID: 'c694525ed0d2c58a7daec7b185e228b7',
  elementID: {
    ButtonSave: '9ae96475fcf64ce73e1936355d894ead',
  },
} as const

export const useRBACFlexiComboChooseProductPage = createUseRBAC(
  flexiComboChooseProductRolesRBAC.elementID,
)

export type UseRBACFlexiComboChooseProductPageType = ReturnType<
  typeof useRBACFlexiComboChooseProductPage
>
